import { Location } from "../Models";
import BookingSearchCriteria from "./BookingSearchCriteria";

export type SearchWithType = 'EMAIL' | 'PHONE_NUMBER' | 'NULL_OR_EMPTY_STRING';
export type BookingLookupResultState = 'START_SHOW_FORM' | 'NO_RELATED_BOOKING' | 'READY_TO_SENT_OTP' | 'SHOW_RESULT' | 'INCORRECT_OTP';
export type EmailOrPhoneValidate = {
    searchWithType: SearchWithType,
    isCorrect: boolean
}

class BookingSearchFormState {
    location: Location;
    checkInDate: string;
    checkOutDate: string;
    emailOrPhone: string;
    searchWithType: SearchWithType;   
    
    isValid() {
        return this.location != null && this.checkInDate != null && this.checkOutDate != null && this.emailOrPhone != null && this.isCorrectEmailOrPhoneFormat(this.emailOrPhone).isCorrect;        
    }

    toBookingSearchCriteria():BookingSearchCriteria {
        if(this.searchWithType == "EMAIL"){
            return new BookingSearchCriteria(this.location, this.checkInDate, this.checkOutDate, this.emailOrPhone, null); 
        }else{
            return new BookingSearchCriteria(this.location, this.checkInDate, this.checkOutDate, null, this.emailOrPhone); 
        }
    }

    isValidEmail(value: string): boolean {
        let emailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        return emailFormat.test(value);
    }

    isValidPhoneNumber(value: string): boolean {
        let phoneNumberFormat = /^09[0-9]{6,10}$/;
        return phoneNumberFormat.test(value);
    }

    isCorrectEmailOrPhoneFormat(value: string): EmailOrPhoneValidate {
        if(value != null && value != ""){
            if(!Number.isNaN(Number(value))) {
                this.searchWithType = "PHONE_NUMBER";
                if(this.isValidPhoneNumber(value)){
                    return {
                        searchWithType: this.searchWithType,
                        isCorrect: true
                    };
                } else {
                    return {
                        searchWithType: this.searchWithType,
                        isCorrect: false
                    };
                }
            } else {
                this.searchWithType = "EMAIL";
                if(this.isValidEmail(value)){
                    return {
                        searchWithType: this.searchWithType,
                        isCorrect: true
                    }
                } else {
                    return {
                        searchWithType: this.searchWithType,
                        isCorrect: false
                    }
                }
            }
            /*if(this.isValidEmail(value)){
                this.searchWithType = "EMAIL";
                return true;
            }else if(this.isValidPhoneNumber(value)){
                this.searchWithType = "PHONE_NUMBER";
                return true;
            }else{
                return false;
            }*/
        }else{
            return {
                searchWithType: "NULL_OR_EMPTY_STRING",
                isCorrect: false
            }
        }
    }
}

export default BookingSearchFormState;